import chalk from 'chalk'

export class ImageHelper {
  private static readonly IMAGE_SIZES = {
    // Thumbnails
    xxs: { width: 255, height: 380, filepath: '_255x380' },
    xs: { width: 300, height: 442, filepath: '_300x442' },
    s: { width: 450, height: 663, filepath: '_450x663' },
    m: { width: 672, height: 990, filepath: '_672x990' },
    l: { width: 713, height: 1050, filepath: '_713x1050' },
    xl: { width: 1069, height: 1575, filepath: '_1069x1575' },
    '2xl': { width: 1426, height: 2100, filepath: '_1426x2100' },

    // Specific sizes
    '80_80': { width: 80, height: 80, filepath: '_80x80' },
    '375_425': { width: 375, height: 420, filepath: '_375x425' },
    '550_623': { width: 550, height: 623, filepath: '_550x623' },
    '160_181': { width: 160, height: 181, filepath: '_160x181' },
    '270_306': { width: 270, height: 306, filepath: '_270x306' },
    '355_402': { width: 355, height: 402, filepath: '_355x402' },
    '585_663': { width: 585, height: 663, filepath: '_585x663' },
    '100_113': { width: 100, height: 113, filepath: '_100x113' },
    '50_67': { width: 50, height: 67, filepath: '_50x67' },
  } as const

  public static getImageUrl(
    url: string,
    size?: keyof typeof ImageHelper.IMAGE_SIZES | '',
    width?: number,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    height?: number,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    quality: number = 80
  ): string {
    if (!url || typeof url !== 'string') return ''

    try {
      // Replace image/ with uploads/ in URL
      url = url.replace('image/', 'uploads/')

      // If size is specified, use predefined dimensions
      if (size && size in ImageHelper.IMAGE_SIZES) {
        const sizeConfig = ImageHelper.IMAGE_SIZES[size]
        width = sizeConfig.width
        // height = sizeConfig.height
      }
      if (process.env.NEXT_PUBLIC_N7_MEDIA_URL) {
        const n7Url = `${process.env.NEXT_PUBLIC_N7_MEDIA_URL}${url}`
        if (width) {
          return `${n7Url}?aio=w-${width}`
        }
        return n7Url
      }

      const widthParam = width ? `width=${width},` : ''
      const heightParam = height ? `height=${height},` : ''
      return `${process.env.NEXT_PUBLIC_MEDIA_URL}/cdn-cgi/image/${widthParam}${heightParam}quality=${quality},format=auto${url}`
    } catch (error) {
      console.error(
        chalk.red('🚀 ~ ImageHelper ~ getImageUrl ~ error:'),
        error,
        url
      )
      return ''
    }
  }

  public static getImageUrlCdn(url: string): string {
    if (!url || typeof url !== 'string') return ''

    try {
      url =
        url.startsWith('image/') || url.startsWith('/image/')
          ? url.replace(/^(\/?image\/)/, '')
          : url

      return `${process.env.NEXT_PUBLIC_MEDIA_CLOUDFLARE}/image/${url}`
    } catch (error) {
      console.error(
        chalk.red('🚀 ~ ImageHelper ~ getImageUrl ~ error:'),
        error,
        url
      )
      return ''
    }
  }
}
